import React from "react";
import Lottie from "react-lottie";
import "./Down_Arrow_Lottie.css";
import * as animationData from "./Down_Arrow_Lottie.json";

function Down_Arrow_Lottie(props) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <section className="main">
      <div className="arrows_div">
        <div className="Down_Arrow_Lottie_icon">
          <Lottie className="me-auto" options={defaultOptions} />
        </div>
      </div>
    </section>
  );
}
export default Down_Arrow_Lottie;
